import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HlmToasterComponent } from '@spartan-ng/ui-sonner-helm';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { ToastService } from './services/toast.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, HlmToasterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    // --- Client-side only logic ---
    if (isPlatformBrowser(this.platformId)) {
      this.checkEmailConfirmation();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Check if the user has returned after confirming email subscription
   */
  private checkEmailConfirmation(): void {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        // Get the queryParams from the current route
        const queryParams = new URLSearchParams(window.location.search);
        const hasConfirmed = queryParams.get('email-confirmation') === 'true';

        if (hasConfirmed) {
          // Show success toast when email is confirmed
          this.toastService.success('Email subscription confirmed! Thank you for subscribing to our newsletter.');

          // Remove the query parameter to prevent showing the toast again on page refresh
          // This creates a new URL without the query parameter
          const urlWithoutParams = window.location.pathname;

          // Navigate to the same route but without the query parameter
          // Use replaceState to avoid adding a new history entry
          window.history.replaceState({}, document.title, urlWithoutParams);
        }
      });
  }
}
